import licenseModule from '../../license.module';
import $ from 'jquery';

export default licenseModule.component('licenseDeactivateStatic', {
    template: require('./licenseDeactivateStatic.component.html'),
    controller: ['LicenseManagementService', licenseDeactivateStaticComponent],
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

function licenseDeactivateStaticComponent(LicenseManagementService) {
    var vm = this;
    vm.processing = false;

    vm.$onInit = function() {
        vm.data = vm.resolve.data;
        vm.license = {
            payload: '',
            hideButton: false
        };
        vm.navs = [
            {
                label: 'Deactivation',
                value: 'deactivation',
                component: 'licenseDeactivateDetail',
                resolve: {
                    subscription: {
                        deviceId: vm.data.allocated.subscription.deviceId,
                        premiumUserId:
                            vm.data.allocated.subscription.premiumUserId
                    },
                    perpetual: {
                        deviceId: vm.data.allocated.perpetual.deviceId,
                        premiumUserId: vm.data.allocated.perpetual.premiumUserId
                    },
                    onlyPerpetual:
                        vm.data.allocated.subscription.deviceId == 0 &&
                        vm.data.allocated.subscription.premiumUserId == 0,
                    name: vm.data.name
                },

                callback: function(data) {
                    vm.eula = data.eula;
                }
            },
            {
                label: 'License',
                value: 'license',
                component: 'licenseDeactivateLicense',
                resolve: {
                    license: vm.license
                },
                disabled: true
            }
        ];
        vm.currentWorkflow = vm.navs[0];
        vm.eula = false;
    };

    vm.cancel = function() {
        if (!vm.processing) {
            vm.dismiss({ $value: 'cancel' });
        }
    };

    vm.deactivate = function() {
        if (!vm.processing) {
            vm.processing = true;
            LicenseManagementService.deactivateInstanceActivation(
                vm.data.id
            ).then(
                function(data) {
                    vm.license.payload = data;
                    vm.navs[0].disabled = true;
                    vm.currentWorkflow = vm.navs[1];
                    $.each(vm.navs, function(index, value) {
                        value.disabled = true;
                        vm.processing = false;
                    });
                },
                function() {
                    vm.license.payload =
                        'Failed to generate license. Please try again. If the problem persists, please contact Appspace Support. ';
                    vm.license.hideButton = true;
                    vm.navs[0].disabled = true;
                    vm.currentWorkflow = vm.navs[1];
                    $.each(vm.navs, function(index, value) {
                        value.disabled = true;
                        vm.processing = false;
                    });
                }
            );
        }
    };

    vm.ok = function() {
        vm.close({ $value: 'ok' });
    };
}



// WEBPACK FOOTER //
// ./modules/license/features/license-deactivate-static/licenseDeactivateStatic.component.js